import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  getAllBlobFileMetaData,
  getAllBlobFileMetaDataFailure,
  getAllBlobFileMetaDataSuccess,

} from "./blob-file.action";
import {BlobFileMetaData} from "../../models/blob-file.model";

export interface BlobFileState {
  blobFileMetaData: BlobFileMetaData[];
  error: string | null;
  status: StateStatus;
}

export const initialState: BlobFileState = {
  blobFileMetaData: [],
  error: null,
  status: 'pending' as StateStatus,
};

export const blobFileReducer = createReducer(
  initialState,
  on(getAllBlobFileMetaData, (state): BlobFileState => ({ ...state, status: 'loading' as StateStatus })),

  on(getAllBlobFileMetaDataFailure, (state, { error }) : BlobFileState => ({
    ...state,
    error: error,
    status: 'loadError' as StateStatus,
  })),
  on(getAllBlobFileMetaDataSuccess, (state, { blobFileMetaData }): BlobFileState => ({
    ...state,
    blobFileMetaData: blobFileMetaData,
    error: null,
    status: 'loadSuccess' as StateStatus,
  })),

);
